//////////////////////////////////////////////////////////////////////////////
/**
 * [Terms] Main References
 */
//////////////////////////////////////////////////////////////////////////////

export const Other = {
    defaultTitle: 'AD Server',
    defaultSuffix: ' :: AD Server',
    login : {
        title: '로그인',
    },
    notFount: {
        title: '404',
    },
    creative: '광고물',
    ssp: 'SSP 네트워크',
    request: '요청',
    impression: '노출',
    impRate: '노출률',
    click: '클릭',
    sales: '매출',
}

export const Setting = {
    campaign: {
        title: '캠페인 관리',
        default: '캠페인',
        breadcrumb: ['캠페인'],
        editing: {
            title: '캠페인 수정',
            breadcrumb: ['캠페인', '수정'],
        },
        new: {
            title: '캠페인 생성',
            breadcrumb: ['캠페인', '생성'],
        },
        history: {
            title: '캠페인 히스토리',
            breadcrumb: ['캠페인', '히스토리'],
        }
    },
    adset: {
        title: '광고 세트 관리',
        default: '광고 세트',
        breadcrumb: ['캠페인', '광고 세트'],
        editing: {
            title: '광고 세트 수정',
            breadcrumb: ['캠페인', '광고 세트', '수정'],
        },
        new: {
            title: '광고 세트 생성',
            breadcrumb: ['캠페인', '광고 세트', '생성'],
        },
        history: {
            title: '광고 세트 히스토리',
            breadcrumb: ['캠페인', '광고 세트', '히스토리'],
        },
    },
    ad: {
        title: '광고 소재 관리',
        default: '광고 소재',
        breadcrumb: ['캠페인', '광고 세트', '광고 소재'],
        editing: {
            title: '광고 소재 설정',
            breadcrumb: ['캠페인', '광고 세트', '광고 소재', '설정'],
        },
        init: {
            title: '광고 소재 설정',
            breadcrumb: ['캠페인', '광고 세트', '광고 소재', '초기 설정'],
        },
    },
    audience: {
        title: '오디언스 관리',
        default: '오디언스',
        breadcrumb: ['오디언스'],
        new: {
            title: '오디언스 생성',
            breadcrumb: ['오디언스', '생성'],
        },
        editing: {
            title: '오디언스 수정',
            breadcrumb: ['오디언스', '수정'],
        },
    },
    adFolder: {
        title: '광고 소재 폴더 관리',
        default: '광고 소재 폴더',
        breadcrumb: ['광고 소재 폴더'],
        new: {
            title: '광고 소재 폴더 생성',
            breadcrumb: ['광고 소재 폴더', '생성'],
        },
        editing: {
            title: '광고 소재 폴더 수정',
            breadcrumb: ['광고 소재 폴더', '수정'],
        },
    },
    inventory: {
        title: '인벤토리 설정',
        default: '인벤토리',
        breadcrumb: ['인벤토리'],
    },
    partner: {
        title: '거래처 관리',
        default: '거래처',
        editing: {
            title: '거래처 정보 수정',
        }
    },
    advertiser: {
        title: '광고주 관리',
        default: '광고주',
        breadcrumb: ['거래처', '광고주'],
        editing: {
            breadcrumb: ['거래처', '광고주', '수정'],
            title: '광고주 정보 수정',            
        },
        new: {
            breadcrumb: ['거래처', '광고주', '생성'],
            title: '광고주 정보 생성',
        }
    },
    activeInventory: {
        title: '활성화 지면 관리',
    }
};
//////////////////////////////////////////////////////////////////////////////
/**
 * 
 * 
 * 
 */
//////////////////////////////////////////////////////////////////////////////

export const Dashboard = {
    dashboard: {
        title: 'Dashboard',
    },
    campaignLive: {
        title: Setting.campaign.default + ' 현황',
    },
    budget: {
        title: Setting.inventory.default + '별 예산소진 현황',
    },
};


export const Report = {
    campaign: {
        title: Setting.campaign.default + '별 리포트',
        breadcrumb: [Setting.campaign.default + ' 리포트'],
    },
    campaignDetail: {
        title: '일별 ' + Setting.campaign.default + ' 세부 리포트',
        breadcrumb: [Setting.campaign.default + ' 리포트', Setting.campaign.default + ' 세부 리포트'],
    },
    campaignWeight: {
        title: Setting.campaign.default + ' 리포트 확정',
    },
    adsetDetail: {
        title: '일별 ' + Setting.adset.default + ' 세부 리포트',
        breadcrumb: [Setting.campaign.default + ' 리포트', Setting.campaign.default + ' 세부 리포트', Setting.adset.default + ' 세부 리포트'],
    },
    sales: {
        monthly: {
            title: '월별 ' + Other.sales,
        },
    },
    inventory: {
        hourly: {
            title: '시간별 '+ Setting.inventory.default +' 리포트'
        },
        daily: {
            title: '일별 '+ Setting.inventory.default +' 리포트',
        },
        monthly: {
            title: '월별 '+ Setting.inventory.default +' 리포트',
        },
    },
    ai: {
        title: Setting.inventory.default +' ' + Other.impression + '량 예측',
    },
};

